import styled from 'styled-components';

export const StyledDeleteWorkflowModal = styled.div`
  width: 100%;

  .desc {
    font-size: 16px;
    line-height: 22px;
    font-weight: 600;
    margin-bottom: 40px;
    color: rgba(49, 49, 49, 1);

    @media (min-width: 576px) {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 70px;
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
